<template>
    <div class="layer-options">
        <q-btn class="layer-options-btn" square icon="layers" title="Cambiar estilo del mapa">
            <q-menu cover anchor="bottom right">
                <q-list>
                    <q-item clickable v-close-popup
                        @click="setMapStyle('mapbox://styles/mapbox/streets-v9')">Streets</q-item>
                    <q-item clickable v-close-popup
                        @click="setMapStyle('mapbox://styles/mapbox/outdoors-v11')">Outdoors</q-item>
                    <q-item clickable v-close-popup
                        @click="setMapStyle('mapbox://styles/mapbox/light-v10')">Light</q-item>
                    <q-item clickable v-close-popup
                        @click="setMapStyle('mapbox://styles/mapbox/dark-v10')">Dark</q-item>
                    <q-item clickable v-close-popup
                        @click="setMapStyle('mapbox://styles/mapbox/satellite-v9')">Satellite</q-item>
                    <q-item clickable v-close-popup
                        @click="setMapStyle('mapbox://styles/mapbox/satellite-streets-v11')">Satellite Streets</q-item>
                    <q-item clickable v-close-popup
                        @click="setMapStyle('mapbox://styles/mapbox/traffic-day-v2')">Traffic Day</q-item>
                    <q-item clickable v-close-popup
                        @click="setMapStyle('mapbox://styles/mapbox/traffic-night-v2')">Traffic Night</q-item>
                </q-list>
            </q-menu>
        </q-btn>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
    name: 'MapboxStyleControl',
    setup(props, { emit }) {
        const setMapStyle = (style: string) => {
            emit('update:style', style);
        }

        return { setMapStyle };
    },
});
</script>

<style lang="scss">
.layer-options {
    &-btn {
        min-width: 29px;
        min-height: 29px;
        background-color: #FFF;
        box-shadow: 0 0 0 2px rgba(0,0,0,.1);
        border-radius: 4px;
        padding: 0px;
    }
}

.q-btn .q-icon, .q-btn .q-spinner {
    font-size: 1.3em;
}
</style>